<script setup lang="ts">
import { ref } from 'vue'

const emit = defineEmits(['update:files'])

interface UploadedFile {
  name: string
  size: string
  url?: string
  file?: File
}

const files = ref<UploadedFile[]>([])
const fileInput = ref<HTMLInputElement | null>(null)

const handleFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (target.files && target.files.length > 0) {
    const selectedFiles = Array.from(target.files)

    const newFiles = selectedFiles.map((file) => ({
      name: file.name,
      size: (file.size / 1024).toFixed(2) + ' KB',
      url: URL.createObjectURL(file),
      file,
    }))

    files.value = [...files.value, ...newFiles]

    emit('update:files', files.value)

    target.value = ''
  }
}

const removeFile = (index: number) => {
  files.value.splice(index, 1)

  emit('update:files', files.value)
}

const showImageModal = ref(false)
const selectedImage = ref<string | null>(null)
</script>

<template>
  <div class="w-full flex flex-col gap-4 ">

    <!-- <span class="text-[13px] font-medium text-[#1b325a]">آپلود فیش واریزی</span> -->

    <div class="grid lg:grid-cols-4 gap-6">

      <div v-for="(file, i) in files" :key="i" class="flex flex-col rounded-xl h-[292.46px] shadow cursor-pointer"
        @click="selectedImage = file.url ?? ''; showImageModal = true">

        <img :src="file.url" class="h-[150px] object-cover rounded-t-xl hover:scale-105 duration-300" />

        <div class="h-1/2 flex flex-col items-center p-4 text-[#00000099] font-medium">
          <span class="text-[12.25px] mb-2 truncate w-full text-center">{{ file.name }}</span>
          <span class="text-[#888] text-[12.6px]">{{ file.size }}</span>

          <button class="flex items-center justify-center cursor-pointer mt-4 w-12 h-12 rounded-full hover:bg-[#fff2f2]"
            @click.stop="removeFile(i)">
            <img src="/svg/delete-3-svgrepo-com.svg" class="w-4" />
          </button>
        </div>
      </div>

      <!-- input -->
      <label
        class="flex flex-col items-center justify-center shadow-md shadow-[#0000001f] h-[150px] rounded-sm border-2 border-dashed text-[#757575] border-[#aaa] cursor-pointer">
        <span>افزودن رسید</span>
        <span class="text-[50px] h-12 font-light">+</span>
        <input type="file" multiple class="hidden" ref="fileInput" @change="handleFileChange" />
      </label>
    </div>

    <!-- modal preview -->
    <Modal :model-value="showImageModal" @update:model-value="showImageModal = $event" width="90vw"
      background="rgba(0,0,0,0.8)" :closable="false" title="">
      <div class="flex justify-center items-center">
        <img :src="selectedImage ?? ''"
          class="max-h-[80vh] rounded-lg shadow-lg transition-all cursor-pointer duration-300" />
      </div>
    </Modal>
  </div>
</template>
